module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-two.82fdcb89.jpg";